import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './stylesheet.css';
import './crt.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store';
import NavBar from 'components/NavBar';
import { Home, TripReport } from 'pages';

const root = ReactDOM.createRoot(document.getElementById('root'));
const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route exact path="/tripreport" element={<TripReport />} />
          <Route exact path="/" element={<Home />} />
          <Route exact path="/:id" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

root.render(<App />);
